import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import generateColors from '../../../utils/generateColors';

import PopulationTables from './PopulationTables';
import PopulationCharts from './PopulationCharts';
import ContactsTable from './ContactsTable';
import IncomeCharts from './IncomeCharts';
import EducationCharts from './EducationCharts';

import geoJsonToEncodedPolylines from '../../../utils/geoJsonToEncodedPolylines';
import { ESRI_YEAR_DEFAULTS } from '../../../constants';
import { API_KEY } from '../../../config';

import './AreaOverview.css';

export function AreaOverviewComponent({ overview, area, activeColor, layer }) {
  const colors = generateColors(activeColor);

  let polygons = area.polygon ? geoJsonToEncodedPolylines(area.polygon) : [];
  if (!Array.isArray(polygons)) polygons = [polygons];

  // Zoom to state level for counties and Country level for states;
  //
  // Builder Designs Key
  // ['key', 'AIzaSyBHoXPOQIS5QR6_EB9NpdMiEoJv9HbITbw'],
  const zoom = layer === 'states' ? '3' : '6';
  const mapParams = [
    ['size', '450x300'],
    ['key', API_KEY],
    ['zoom', zoom],
    ...polygons.map(polygon => ['path', `color:black|enc:${encodeURI(polygon)}`]),
  ];

  // For states, client requests we show entire US map
  if (layer === 'states') {
    mapParams.push(
      ['center', '39.8097343, -98.5556199'],
    );
  }

  // For communities, slam a pin into the center
  if (layer === 'communities') {
    mapParams.push(
      ['markers', `color:${activeColor.replace('#', '0x')}|${area.name},${area.state}`],
    );
  }

  const mapQuery = mapParams.map(([key, value]) => `${key}=${value}`).join('&');

  const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?${mapQuery}`;

  return (
    <div className="area-overview">
      <div className="detail-col-1">
        { mapUrl.length <= 8192 &&
        <div>
          <img
            alt={`map of ${area.name}`}
            src={mapUrl}
          />
        </div> }

        <PopulationTables
          overview={overview}
        />

        <ContactsTable
          overview={overview}
        />
      </div>
      <div className="detail-col-2">
        <section>
          <div className="section-body">
            {overview.details && overview.details.description}
          </div>
        </section>

        <PopulationCharts
          colors={colors}
          overview={overview}
        />

        <IncomeCharts
          colors={colors}
          overview={overview}
        />

        <EducationCharts
          colors={colors}
          overview={overview}
        />

        <div className="data-credit">
          Source: ESRI<sup>&reg;</sup>, {ESRI_YEAR_DEFAULTS.currentYear}
        </div>
      </div>
    </div>
  );
}

AreaOverviewComponent.propTypes = {
  overview: PropTypes.object,
  area: PropTypes.shape({
    name: PropTypes.string,
    polygon: PropTypes.object,
  }),
  activeColor: PropTypes.string,
  layer: PropTypes.string,
};
export default connect(
  state => ({
    activeColor: state.viewer.activeColor,
  }),
)(AreaOverviewComponent);



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/AreaOverview.js